export default "__VITE_ASSET__e3035b85__"